import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from '../features/Auth/_redux/authSlice';
import { blogSlice } from '../features/Blog/_redux/blogSlice';
import { contactSlice } from '../features/Contact/_redux/contactSlice';
import { httpSlice } from '../features/Http/_redux/httpSlice';
import { packageSlice } from '../features/Package/_redux/packageSlice';
import { sessionSlice } from '../features/Session/_redux/sessionSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    http: httpSlice.reducer,
    packages: packageSlice.reducer,
    session: sessionSlice.reducer,
    contact: contactSlice.reducer,
    blog: blogSlice.reducer
  },
  devTools: process.env.NODE_ENV === 'development'
});
